/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('layout-row', 'layout-align-center')
export default class FilterBar extends Component {
  onChange() {}

  @action
  setFilterValue(filterValue) {
    this.onChange(filterValue);
  }
}
